import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const PostAdd = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.5837 4.16687H35.4169V10.4169H29.1669C29.1875 10.4375 29.1669 14.5837 29.1669 14.5837H35.4169V20.8131C35.4375 20.8337 39.5837 20.8131 39.5837 20.8131V14.5837H45.8337V10.4169H39.5837V4.16687Z"
        fill={color}
      />
      <path
        d="M35.4169 40.0419H10.4169V14.5837H25V10.4169H10.4169C9.31271 10.42 8.25467 10.86 7.47391 11.6408C6.69315 12.4215 6.25313 13.4796 6.25 14.5837V39.5837C6.25313 40.6879 6.69315 41.7459 7.47391 42.5267C8.25467 43.3075 9.31271 43.7475 10.4169 43.7506H35.4169C36.521 43.7475 37.5791 43.3075 38.3598 42.5267C39.1406 41.7459 39.5806 40.6879 39.5837 39.5837V25H35.4169V40.0419Z"
        fill={color}
      />
      <path d="M14.5831 18.75H31.25V22.9169H14.5831V18.75Z" fill={color} />
      <path d="M14.5831 25V29.1669H31.25V25H14.5831Z" fill={color} />
      <path d="M14.5831 31.25H31.25V35.4169H14.5831V31.25Z" fill={color} />
    </svg>
  )
}
